import {Component, ChangeDetectionStrategy, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MerchantAd} from '../../../../core/dtos/api';

@Component({
    templateUrl: './conversion-rate-dialog.component.html',
    styleUrls: ['./conversion-rate-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConversionRateDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public merchantAd: MerchantAd) {}
}
